import {useMemo} from 'react';
import {useLocation} from 'react-router';
import {ROUTES} from 'core';

const useCheckLocation = () => {
  const location = useLocation();

  const is503Page = useMemo(
    () => location.pathname.toLowerCase() === ROUTES.System.Error503,
    [location.pathname]
  );

  const isOAuthCallbackPage = useMemo(
    () => location.pathname.toLowerCase().includes('/oauth2/finish'),
    [location.pathname]
  );

  return {is503Page, isOAuthCallbackPage};
};

export {useCheckLocation};
